import { APICore } from "./apiCore";

const api = new APICore();

function ApiGetAllLayanan(params: any): any {
  const baseUrl = "/api/admin/layanan";
  return api.get(`${baseUrl}`, params);
}

function ApiPostLayanan(params: any): any {
  const baseUrl = "/api/admin/layanan";
  return api.create(`${baseUrl}`, params);
}

function ApiEditLayanan(id: any, params: any): any {
  const baseUrl = "/api/admin/layanan";
  return api.update(`${baseUrl}/${id}`, params);
}

function ApiDeleteLayanan(id: any): any {
  const baseUrl = "/api/admin/layanan";
  return api.delete(`${baseUrl}/${id}`);
}

export { ApiGetAllLayanan, ApiPostLayanan, ApiEditLayanan, ApiDeleteLayanan };
